import { useMutation, gql } from '@apollo/client';
import {
  EditarCursoMutation,
  EditarCursoMutationVariables,
} from './__generated__/EditarCursoMutation';

const EDITAR_CURSO_MUTATION = gql`
  mutation EditarCursoMutation(
    $id_curso: Int!
    $id_unidade: Int
    $dsc_nome_curso: String
    $dsc_sigla_curso: String
    $id_apoio: Int
    $ativo: Boolean!
  ) {
    editarCurso(
      input: {
        id_curso: $id_curso
        id_unidade: $id_unidade
        dsc_nome_curso: $dsc_nome_curso
        dsc_sigla_curso: $dsc_sigla_curso
        id_apoio: $id_apoio
        ativo: $ativo
      }
    ) {
      id_curso
      id_unidade
      dsc_nome_curso
      dsc_sigla_curso
      id_apoio
      apoio {
        id_apoio
        dsc_nome
      }
      ativo

      ofertas {
        id_oferta
        num_oferta
        num_ano
        num_semestre
        ativa
        id_assistente
        assistente {
          id_assistente
          dsc_nome
          dsc_email
        }
        dat_inicio
        dat_fim

        turmas {
          id_turma
          id_horario
          num_turma
          dias_semana
          ativa
        }
      }
    }
  }
`;

const useEditarCursoMutation = () => {
  return useMutation<EditarCursoMutation, EditarCursoMutationVariables>(EDITAR_CURSO_MUTATION);
};

export { useEditarCursoMutation };
